import { Link } from 'react-router-dom';
import { useTheme } from '../../../hooks/useTheme';

/*
  Bloque de acceso a InnoFlex Odontología dentro del área de Industrias.
  Es aditivo: no reemplaza ni modifica ninguna industria existente.
*/

const HIGHLIGHTS = [
  { icon: 'ri-calendar-check-line', label: 'Agenda y pacientes' },
  { icon: 'ri-tooth-line', label: 'Odontograma' },
  { icon: 'ri-file-list-3-line', label: 'Tratamientos' },
  { icon: 'ri-cash-line', label: 'Caja y cobros' },
  { icon: 'ri-archive-2-line', label: 'Inventario' },
  { icon: 'ri-line-chart-line', label: 'Reportes' },
];

export default function DentalCallout() {
  const { theme } = useTheme();
  const isLight = theme === 'light';
  const accentText = isLight ? '#0f766e' : '#14b8a6';

  const ink = isLight ? '#0a1628' : '#ffffff';
  const sub = isLight ? 'rgba(10,22,40,0.72)' : 'rgba(255,255,255,0.58)';

  return (
    <section id="odontologia" className="py-12 md:py-16 px-4 sm:px-6">
      <div
        className="max-w-6xl mx-auto rounded-2xl border p-6 sm:p-8 lg:p-10 relative overflow-hidden"
        style={{
          borderColor: 'rgba(6,182,212,0.30)',
          background: isLight
            ? 'linear-gradient(135deg, #f6fafd 0%, #eef8f6 100%)'
            : 'linear-gradient(135deg, rgba(6,182,212,0.10) 0%, rgba(7,27,46,0.92) 60%)',
          boxShadow: isLight
            ? '0 10px 34px rgba(6,182,212,0.12)'
            : '0 18px 44px rgba(0,0,0,0.35)',
        }}
      >
        <div
          className="absolute top-0 right-0 w-72 h-72 rounded-full pointer-events-none"
          style={{
            background: 'radial-gradient(circle, rgba(20,184,166,0.14) 0%, transparent 70%)',
            transform: 'translate(35%, -35%)',
          }}
        />

        <div className="relative z-10 flex flex-col lg:flex-row lg:items-center gap-7">
          <div className="flex-1">
            <span
              className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border text-[11px] font-bold tracking-wider uppercase mb-4 font-body"
              style={{
                borderColor: 'rgba(6,182,212,0.35)',
                backgroundColor: 'rgba(6,182,212,0.10)',
                color: isLight ? '#0e7490' : '#22d3ee',
              }}
            >
              <i className="ri-tooth-line text-sm" aria-hidden="true" />
              ¿Diriges una clínica odontológica?
            </span>

            <h2
              className="font-heading text-2xl sm:text-3xl font-extrabold mb-3 leading-snug"
              style={{ color: ink }}
            >
              Gestiona toda tu clínica desde{' '}
              <span style={{ color: accentText }}>una sola plataforma</span>
            </h2>

            <p className="font-body text-sm sm:text-base leading-relaxed max-w-2xl mb-5" style={{ color: sub }}>
              Controla pacientes, agenda, historia clínica, odontograma, tratamientos, cobros,
              inventario y crecimiento desde InnoFlex.
            </p>

            <ul className="flex flex-wrap gap-2">
              {HIGHLIGHTS.map((item) => (
                <li
                  key={item.label}
                  className="flex items-center gap-1.5 rounded-full px-3 py-1.5 font-body text-[11px] font-semibold"
                  style={{
                    backgroundColor: isLight ? 'rgba(6,182,212,0.09)' : 'rgba(255,255,255,0.05)',
                    border: isLight
                      ? '1px solid rgba(6,182,212,0.20)'
                      : '1px solid rgba(255,255,255,0.09)',
                    color: isLight ? 'rgba(10,22,40,0.66)' : 'rgba(255,255,255,0.62)',
                  }}
                >
                  <i className={`${item.icon} text-xs`} style={{ color: '#14b8a6' }} aria-hidden="true" />
                  {item.label}
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-shrink-0">
            <Link
              to="/odontologia"
              className="inline-flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-full font-body text-sm font-extrabold transition-all duration-200 hover:scale-[1.03] active:scale-[0.97] cursor-pointer whitespace-nowrap"
              style={{
                background: 'linear-gradient(135deg, #06b6d4 0%, #14b8a6 100%)',
                color: '#04101f',
                boxShadow: '0 8px 26px rgba(6,182,212,0.30)',
              }}
            >
              Conocer InnoFlex Odontología
              <i className="ri-arrow-right-line text-base" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
